/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "ஏற்றுகிறது"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var taIN = Object.assign(TranslationProviderComponent, {
  translations
});

export { taIN as t };
//# sourceMappingURL=ta-IN-Dkko6b7k.js.map
